import { useFormik } from "formik";
import SaleEngineSchema from "./saleEngineSchema";
import { REACTIVE_ADVANCED_DEFAULTS } from "./components/ReactiveConfig";

export const useSaleEngineFormConfig = () => {
  const saleEngineForm = useFormik({
    initialValues: {
      saleType: "Fixed",
      stopProfit: 3,
      triggerProfit: 2,
      stopLoss: 3,
      ...REACTIVE_ADVANCED_DEFAULTS,
    },
    validationSchema: SaleEngineSchema,
    onSubmit: async () => {},
  });

  return { saleEngineForm };
};
